import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchReporterList } from "../../../../actions/filters-actions";
import { FILTER_NAMES } from "../../../../constants/app-constant";
import useDebounce from "../../../../custom_hooks/debounce";
import { TagClose } from "../../../Icons/icons.component";
import { Input } from "../../../Shared/FormElements/Input";

const { REMOVE_REPORTER_TEXT, TYPED_REPORTER_TEXT, REPORTER } = FILTER_NAMES;

export default function SourceFilter({ filters, handleFilterSelect }) {
  const dispatch = useDispatch();
  const { typedReporter, source_type } = filters;

  const typedReportSearchKey = useDebounce(typedReporter, 700);

  useEffect(() => {
    const correctText = Array.isArray(typedReporter)
      ? typedReporter.join(",")
      : typedReporter;
    dispatch(fetchReporterList(source_type, correctText));
  }, [typedReportSearchKey]);

  const typedReporterLength =
    filters.typedReporter && filters.typedReporter.length;

  const reporterDataList =
    useSelector((state) => state.filterReducer.reporterData) || [];

  const [checkedId, setCheckedId] = useState([]);

  useEffect(() => {
    if (filters && filters.reporter) {
      setClass();
    }
  }, [filters]);

  const setClass = () => {
    if (filters && filters.reporter) {
      setCheckedId(filters.reporter.map((i) => i.id));
    }
  };

  return (
    <div id="reporterFilterContainer" className="form-group">
      <div className="filterDiv filteInputText">
        <label>Journalist</label>
        <div className="tagTileWrap">
          {filters.reporter &&
            filters.reporter.map((e) => (
              <span
                onClick={() => handleFilterSelect(REMOVE_REPORTER_TEXT, e)}
                className="tagTile"
              >
                {e.text}
                <span className="tagTileRemove"><TagClose /></span>
              </span>
            ))}
          <Input
            id="reporter-filter"
            type="text"
            onChange={(value) => {
              handleFilterSelect(TYPED_REPORTER_TEXT, value);
            }}
            value={filters.typedReporter}
            placeholder="Journalist"
          // disabled={!filters.source_type}
          ></Input>
          <ul
            id="dynamic-list-data"
            className={`autoSuggest ${typedReporterLength ? "show" : "hide"}`}
          >
            {!reporterDataList.length ? (
              <li>Searching...</li>
            ) : (
              reporterDataList.map(({ id, text }) => {
                return (
                  <li
                    onClick={(e) => {
                      handleFilterSelect(REPORTER, { text, id });
                    }}
                    key={id}
                    value={id}
                    className={
                      checkedId.indexOf(id.toString()) != -1
                        ? "filterOption bg-gray"
                        : "filterOption"
                    }
                  >
                    {text}
                  </li>
                );
              })
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}
